module.exports = __webpack_public_path__ + "static/media/dish4.9fc74a79.jpg";